export default "__VITE_ASSET__C6Icl_mP__"